import React from "react";

import Radio from "antd/es/radio";
import { useIntl } from "react-intl";

import Option from "@app/component/input/LabeledSwitch/Option";
import RadioGroup from "@app/component/input/RadioGroup";
import ImportRestrictionValue from "@app/enum/ImportRestrictionValue";

import styles from "./ImportRestriction.module.scss";

interface Props {
  onChange?: (value: ImportRestrictionValue) => void;
  value?: ImportRestrictionValue;
}

const ImportRestriction: React.FC<Props> = ({ onChange, value }) => {
  const intl = useIntl();

  return (
    <Option
      title={intl.formatMessage({
        id: "settings.organizationDetails.data.importAllowed.title",
        defaultMessage: "Restrict ability to import by role",
        description: "Settings organization details - Data - Import restriction - Title",
      })}
    >
      <div>
        {intl.formatMessage({
          id: "settings.organizationDetails.data.importAllowed.description",
          defaultMessage: "Only allow these roles to import data:",
          description: "Settings organization details - Data - Import restriction - description",
        })}
      </div>
      <RadioGroup<ImportRestrictionValue> onChange={onChange} size="small" value={value}>
        <div className={styles.options}>
          <Radio value={ImportRestrictionValue.OWNER}>
            {intl.formatMessage({
              id: "settings.organizationDetails.data.importAllowed.check.owner",
              defaultMessage: "Organization owner only",
              description: "Settings organization details - Import restriction - owner",
            })}
          </Radio>
          <Radio value={ImportRestrictionValue.OWNER_MANAGERS}>
            {intl.formatMessage({
              id: "settings.organizationDetails.data.importAllowed.check.owner_managers",
              defaultMessage: "Team managers and owner",
              description: "Settings organization details - Import restriction - owner managers",
            })}
          </Radio>
          <Radio value={ImportRestrictionValue.ALL_USERS}>
            {intl.formatMessage({
              id: "settings.organizationDetails.data.importAllowed.check.all_users",
              defaultMessage: "All users",
              description: "Settings organization details - Import restriction - organization",
            })}
          </Radio>
        </div>
      </RadioGroup>
    </Option>
  );
};

export default ImportRestriction;
